import useOptimisticCreateCustomFieldGroup from '@/api/mutations/account/optimistic/useOptimisticCreateCustomFieldGroup';
import useGetMyCustomFieldGroups from '@/api/queries/me/useGetMyCustomFieldGroups';
import { AnchorButton } from '@payaca/ambrosia';

import { FC, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { CustomFieldGroupControl } from '../customFieldGroupControl/CustomFieldGroupControl';

export const CompanySettingsProjectCustomFields: FC = () => {
  const { data: customFieldGroups } = useGetMyCustomFieldGroups();

  const projectCustomFieldGroup = useMemo(
    () => customFieldGroups?.find((x) => x.role === 'project'),
    [customFieldGroups]
  );

  const { mutateAsync: createCustomFieldGroup } =
    useOptimisticCreateCustomFieldGroup();

  useEffect(() => {
    if (
      customFieldGroups &&
      !customFieldGroups.find((x) => x.role === 'project')
    ) {
      void createCustomFieldGroup({
        role: 'project',
        id: uuid(),
      });
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'createCustomFieldGroup'
  }, [customFieldGroups]);

  if (!projectCustomFieldGroup) {
    return null;
  }

  return (
    <CustomFieldGroupControl
      customFieldGroup={projectCustomFieldGroup}
      heading="Project Custom Fieldsets"
      subHeading="Once created Custom Fieldsets can be set on each Project page."
      headerAction={
        <AnchorButton as={Link} to="/document-blueprints" variant="link">
          Browse Document blueprints
        </AnchorButton>
      }
    />
  );
};
